/* eslint-disable import/no-cycle */
import Http from '@/api/http';
/* eslint-enable import/no-cycle */

export default class CustomerDetail {
    static basePath = '/customer/detail';

    /**
     * get user login information by ssoId
     *
     * @param ssoId
     * @returns Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static login(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/login`);
    }

    /**
     * get user contractor ids by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static contractors(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/contractors`);
    }

    /**
     * get masterdata from celeraone by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static masterdataCeleraone(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/masterdata/celeraone`);
    }

    /**
     * get masterdata from mhn SAP by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static masterdataSapMhn(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/masterdata/sap/mhn`);
    }

    /**
     * get masterdata from noz SAP by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static masterdataSapNoz(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/masterdata/sap/noz`);
    }

    /**
     * get evalanche masterdata by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static masterdataEvalanche(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/masterdata/evalanche`);
    }

    /**
     * get salesforce masterdata by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static masterdataSalesforce(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/masterdata/salesforce`);
    }

    /**
     * get user info from celeraone by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static info(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/info`);
    }

    /**
     * get entitlements by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static entitlements(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/entitlements`);
    }

    /**
     * get purchases from celeraone by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static purchasesCeleraone(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/purchases/celeraone`);
    }

    /**
     * get purchases from mhn SAP by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static purchasesSapMhn(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/purchases/sap/mhn`);
    }

    /**
     * get purchases from noz SAP by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static purchasesSapNoz(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/purchases/sap/noz`);
    }

    /**
     * get user properties by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static properties(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/properties`);
    }

    /**
     * get user optins from celeraone by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static optins(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/optins`);
    }

    /**
     * get usergroups from celeraone by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Johann Prenzler <johann.prenzler@noz-digital.de>
     */
    static usergroups(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/usergroups`);
    }

    /**
     * get atom summary by ssoId
     *
     * @param ssoId
     * @return Promise
     *
     * @author Lukas Wilkes <lukas.wilkes@hhlab.de>
     */
    static linkedAccountsSummary(ssoId) {
        return Http.get(`${CustomerDetail.basePath}/${ssoId}/atoms`);
    }
}
